/**
 * Catálogo de ilustrações (SVG inline) por alimento — imagens padrão da ferramenta,
 * pra não depender de o cuidador fotografar cada item (atrito que mata a adesão).
 *
 * São vetoriais, offline, sem licença (autoradas aqui) e viram data-URI no <img>.
 * A referência guardada em Alimento.fotos[] é "cat:<chave>" (ex.: "cat:banana"),
 * diferente de um id de Blob (foto real do usuário). O usuário pode trocar pela foto
 * real do item específico quando quiser — aí passa a valer a foto dele.
 *
 * As chaves são o nome normalizado (sem acento), pra casar com o catálogo de
 * populares (lib/catalogo.ts) e com o nome do alimento.
 */
import { normalizarNome } from "./catalogo";

const bg = (inner: string) =>
  `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 96 96"><rect width="96" height="96" rx="20" fill="#f3efe8"/>${inner}</svg>`;

/** chave (nome normalizado) → SVG da ilustração */
export const ILUSTRACOES: Record<string, string> = {
  maca: bg(
    `<path d="M40 34c-6 0-12 7-12 19 0 13 9 24 18 20 9 4 18-7 18-20 0-12-6-19-12-19-4 0-6 4-6 4s-2-4-6-4z" fill="#e2533b"/><rect x="46" y="22" width="4" height="13" rx="2" fill="#7a5230"/><path d="M50 27c4-6 12-7 16-4-2 7-11 8-16 4z" fill="#5aa55a"/>`,
  ),
  banana: bg(
    `<path d="M30 28c-5 22 8 42 34 40 6-1 10-6 10-12-8 8-22 6-30-4-8-10-8-18-2-26-4-2-10-2-12 2z" fill="#f1c33e"/><circle cx="31" cy="27" r="3" fill="#9c7b2e"/><path d="M72 54c2 0 4 1 4 4" stroke="#9c7b2e" stroke-width="3" stroke-linecap="round" fill="none"/>`,
  ),
  morango: bg(
    `<path d="M48 40c16 0 22 10 18 21-4 12-14 19-18 19s-14-7-18-19c-4-11 2-21 18-21z" fill="#e23b4e"/><path d="M48 43c-4-8-12-10-16-12 6 0 12 2 16 7 4-5 10-7 16-7-4 2-12 4-16 12z" fill="#5aa55a"/><g fill="#f6d36b"><circle cx="42" cy="54" r="1.6"/><circle cx="54" cy="54" r="1.6"/><circle cx="48" cy="62" r="1.6"/><circle cx="38" cy="64" r="1.6"/><circle cx="58" cy="64" r="1.6"/></g>`,
  ),
  laranja: bg(
    `<circle cx="48" cy="54" r="22" fill="#f0852c"/><circle cx="41" cy="47" r="5" fill="#f6a85a"/><path d="M50 32c6-6 14-6 18-2-4 6-13 7-18 2z" fill="#5aa55a"/>`,
  ),
  tomate: bg(
    `<circle cx="48" cy="56" r="21" fill="#e2453b"/><circle cx="41" cy="50" r="4" fill="#ef7163"/><path d="M48 34c-5 0-9 3-9 3s4 6 9 6 9-6 9-6-4-3-9-3z" fill="#5aa55a"/><rect x="46" y="30" width="4" height="8" rx="2" fill="#5aa55a"/>`,
  ),
  cenoura: bg(
    `<path d="M48 80 36 42c8-4 16-4 24 0z" fill="#f0822c"/><g stroke="#d96f1e" stroke-width="2" stroke-linecap="round"><path d="M44 52l8 0"/><path d="M43 60l10 0"/></g><g stroke="#5aa55a" stroke-width="4" stroke-linecap="round"><path d="M40 42 34 28"/><path d="M48 42 48 26"/><path d="M56 42 62 28"/></g>`,
  ),
  brocolis: bg(
    `<rect x="44" y="54" width="8" height="20" rx="3" fill="#b6c07e"/><circle cx="39" cy="46" r="12" fill="#4f8a3f"/><circle cx="57" cy="46" r="12" fill="#5a9a48"/><circle cx="48" cy="37" r="13" fill="#4f8a3f"/><circle cx="48" cy="49" r="11" fill="#5a9a48"/>`,
  ),
  arroz: bg(
    `<path d="M26 54q22-18 44 0a22 14 0 0 1-44 0z" fill="#fff" stroke="#e3e6e0"/><path d="M24 54h48a24 16 0 0 1-48 0z" fill="#cfd6db"/><g fill="#fff"><ellipse cx="40" cy="48" rx="3" ry="1.6"/><ellipse cx="50" cy="45" rx="3" ry="1.6"/><ellipse cx="58" cy="49" rx="3" ry="1.6"/></g>`,
  ),
  pao: bg(
    `<path d="M28 58c0-16 12-22 20-22s20 6 20 22c0 8-8 10-20 10s-20-2-20-10z" fill="#d9a86a" stroke="#b9854a" stroke-width="2"/><g stroke="#b9854a" stroke-width="2" stroke-linecap="round"><path d="M40 46l-3 8"/><path d="M48 44l0 9"/><path d="M56 46l3 8"/></g>`,
  ),
  batata: bg(
    `<ellipse cx="48" cy="54" rx="23" ry="16" fill="#caa472"/><g fill="#a9824f"><circle cx="40" cy="50" r="1.8"/><circle cx="54" cy="48" r="1.6"/><circle cx="50" cy="58" r="1.8"/><circle cx="60" cy="56" r="1.4"/></g>`,
  ),
  leite: bg(
    `<path d="M37 32h22l-2 38a3 3 0 0 1-3 3H42a3 3 0 0 1-3-3z" fill="#eef2f5" stroke="#cfd6db" stroke-width="2"/><path d="M39 48h18l-1 22a3 3 0 0 1-3 3H43a3 3 0 0 1-3-3z" fill="#fff"/>`,
  ),
  queijo: bg(
    `<path d="M24 62 66 38l6 24z" fill="#f3c64b" stroke="#e0b13a" stroke-width="2"/><g fill="#e0b13a"><circle cx="46" cy="56" r="3"/><circle cx="57" cy="53" r="2.4"/><circle cx="52" cy="60" r="1.8"/></g>`,
  ),
  ovo: bg(
    `<path d="M34 46c-4-10 12-18 18-10 7-6 20 4 14 14 7 6-2 20-13 16-7 6-22 0-20-10-6-2-5-8 1-10z" fill="#fff" stroke="#ececec" stroke-width="2"/><circle cx="49" cy="52" r="10" fill="#f4b740"/>`,
  ),
  biscoito: bg(
    `<circle cx="48" cy="52" r="22" fill="#caa06a"/><g fill="#6b4423"><circle cx="42" cy="46" r="3"/><circle cx="55" cy="48" r="2.6"/><circle cx="46" cy="58" r="2.6"/><circle cx="56" cy="58" r="2"/></g>`,
  ),
};

/** rótulos bonitos pra exibição no seletor */
export const ROTULOS_ILUSTRACAO: Record<string, string> = {
  maca: "maçã",
  banana: "banana",
  morango: "morango",
  laranja: "laranja",
  tomate: "tomate",
  cenoura: "cenoura",
  brocolis: "brócolis",
  arroz: "arroz",
  pao: "pão",
  batata: "batata",
  leite: "leite",
  queijo: "queijo",
  ovo: "ovo",
  biscoito: "biscoito",
};

/** chaves disponíveis (pra montar a grade do seletor) */
export const CHAVES_ILUSTRACAO = Object.keys(ILUSTRACOES);

/** "cat:<chave>" → data-URI do SVG; "" se não existir. */
export function urlIlustracao(ref: string): string {
  const chave = ref.startsWith("cat:") ? ref.slice(4) : ref;
  const svg = ILUSTRACOES[chave];
  return svg ? `data:image/svg+xml,${encodeURIComponent(svg)}` : "";
}

/** É uma referência de ilustração do catálogo (vs id de Blob real)? */
export const ehRefCatalogo = (ref?: string | null): boolean =>
  !!ref && ref.startsWith("cat:");

/** Dado um nome de alimento, devolve "cat:<chave>" se houver ilustração; senão null. */
export function refIlustracaoPorNome(nome: string): string | null {
  const n = normalizarNome(nome);
  if (ILUSTRACOES[n]) return `cat:${n}`;
  const primeira = n.split(" ")[0];
  return ILUSTRACOES[primeira] ? `cat:${primeira}` : null;
}
